import { render, staticRenderFns } from "./ShowCase.vue?vue&type=template&id=5b634f5b&scoped=true&"
import script from "./ShowCase.vue?vue&type=script&lang=js&"
export * from "./ShowCase.vue?vue&type=script&lang=js&"
import style0 from "./ShowCase.vue?vue&type=style&index=0&id=5b634f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b634f5b",
  null
  
)

export default component.exports